import { styled, Paper } from '@mui/material';

export const CodeEditorCard = styled(Paper)(({ theme }) => ({
  borderRadius: '12px',
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
  backgroundImage: 'none',
}));
